"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_config_1 = __importDefault(require("react-native-config"));
const react_redux_1 = require("react-redux");
const slice_1 = require("../../../app-reduxs/login/slice");
const actions_1 = __importDefault(require("../../../app-reduxs/loginFirebase/actions"));
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const EyeLogin_1 = __importDefault(require("../../../assets/icons/EyeLogin"));
const EyeSlashLogin_1 = __importDefault(require("../../../assets/icons/EyeSlashLogin"));
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const InputField_1 = __importDefault(require("../../../components/input/InputField"));
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const ModalExplain_1 = __importDefault(require("../../../components/modal/ModalExplain"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = __importDefault(require("../../../constants/constants"));
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Auth_1 = __importDefault(require("../../../networking/apis/Auth"));
const User_1 = __importDefault(require("../../../networking/apis/User"));
const AsyncStorage_1 = __importDefault(require("../../../utils/AsyncStorage"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const InputPassword = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [email, setEmail] = (0, react_1.useState)('');
    const [passWord, setPassWord] = (0, react_1.useState)("");
    const [visiblePassWord, setVisiblePassWord] = (0, react_1.useState)(false);
    const [isShowPassWord, setShowPassword] = (0, react_1.useState)(false);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [errorText, setErrorText] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        (async () => {
            const _email = await AsyncStorage_1.default.get(constants_1.default.AUTH_EMAIL);
            if (!!_email) {
                setEmail(_email);
            }
        })();
        return () => {
            AsyncStorage_1.default.remove(constants_1.default.AUTH_EMAIL);
        };
    }, []);
    const getUserProfile = async () => {
        const response = await User_1.default.retrieveUser();
        if (response.status == 200) {
            dispatch((0, slice_1.setProfileAction)(response.data.data));
        }
        return response;
    };
    const handleLogin = () => {
        if (passWord.length < 4 || passWord.length > 50) {
            setErrorText('パスワードは、4文字以上で指定してください。');
            return;
        }
        setLoading(true);
        Auth_1.default.loginWithFujisan(email, passWord)
            .then(async (response) => {
            const { token, refresh_token } = response.data;
            AsyncStorage_1.default.set(constants_1.default.ACCESS_TOKEN_LOCAL, token);
            AsyncStorage_1.default.set(constants_1.default.REFRESH_TOKEN_LOCAL, refresh_token);
            AsyncStorage_1.default.remove(constants_1.default.FIREBASE_TOKEN);
            AsyncStorage_1.default.remove(constants_1.default.AUTH_EMAIL);
            dispatch((0, slice_1.saveAccessTokenAction)(token));
            dispatch(actions_1.default.loginFirebaseStartAction());
            const _response = await getUserProfile().finally(() => setLoading(false));
            if (response.data?.is_withdraw_account) {
                await AsyncStorage_1.default.set(constants_1.default.IS_COMPLETED_TUTORIAL, 0);
                (0, rootNavigation_1.navigate)(Routes_1.default.REGISTER, { isExist: 1 });
                return;
            }
            const isCompleteTutorial = await AsyncStorage_1.default.get(constants_1.default.IS_COMPLETED_TUTORIAL);
            if (_response?.data?.data?.registration_status != 0 &&
                isCompleteTutorial != '1') {
                (0, rootNavigation_1.navigate)(Routes_1.default.AUTH_NAVIGATOR, {
                    screen: Routes_1.default.TUTORIAL,
                });
                return;
            }
            (0, rootNavigation_1.reset)({ index: 0, routeName: Routes_1.default.MAINTABBAR });
        })
            .catch(err => {
            if (err?.response?.data?.error?.message?.password) {
                setErrorText(err?.response.data.error.message.password.join('\n'));
            }
            else if (err?.response?.data?.error?.message) {
                setErrorText(err?.response.data.error.message);
            }
            setLoading(false);
        });
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
            justifyContent: "space-between",
        }, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, title: "ログイン", styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: "#21242D" }), onLeftPress: rootNavigation_1.goBack }),
            react_1.default.createElement(react_native_1.KeyboardAvoidingView, null,
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.loginForm },
                    react_1.default.createElement(react_native_1.Image, { source: images_1.images.LogoTextApp, style: {
                            height: (0, scale_1.scale)(50),
                            width: (0, scale_1.scale)(139),
                            marginBottom: (0, scale_1.scale)(35),
                        } }),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            fontWeight: "300",
                        } },
                        react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                                fontSize: (0, scale_1.moderateScale)(15),
                                lineHeight: (0, scale_1.moderateScale)(23),
                                color: "#292A33",
                            } }, email),
                        `パスワードを入力してログインしてください。`),
                    react_1.default.createElement(InputField_1.default, { style: styles_1.default.input, placeholder: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B", placeholderTextColor: "#C8C8C8", label: "パスワード", value: passWord, errorText: errorText, onChangeText: (text) => {
                            setPassWord(text?.trim());
                        }, secureTextEntry: !isShowPassWord, rightIcon: isShowPassWord ? (react_1.default.createElement(EyeSlashLogin_1.default, { style: styles_1.default.iconInputLogin })) : (react_1.default.createElement(EyeLogin_1.default, { style: styles_1.default.iconInputLogin })), onRightIconPress: () => { setShowPassword(!isShowPassWord); } }),
                    react_1.default.createElement(components_1.LinkButton, { style: { marginTop: (0, scale_1.scale)(10), alignSelf: "flex-start" }, title: '\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u304A\u5FD8\u308C\u306E\u65B9\u306F\u3053\u3061\u3089', textStyle: { fontSize: (0, scale_1.scale)(14) }, onPress: () => {
                            const url = react_native_1.Platform.OS == 'web' ? process.env.FORGOT_PASSWORD_URL : react_native_config_1.default.FORGOT_PASSWORD_URL;
                            react_native_1.Linking.openURL(url);
                        } }),
                    react_1.default.createElement(components_1.LinearButton, { title: '\u30ED\u30B0\u30A4\u30F3', containerStyle: { marginTop: (0, scale_1.scale)(32), width: '100%' }, onPress: handleLogin, style: {
                            width: '100%',
                            height: (0, scale_1.scale)(48),
                            borderRadius: (0, scale_1.scale)(4),
                        }, fontWeight: "600", textStyle: {
                            fontSize: (0, scale_1.moderateScale)(16),
                            lineHeight: (0, scale_1.moderateScale)(24),
                        } })))),
        react_1.default.createElement(react_native_1.View, { style: {
                width: "100%",
                bottom: 0,
                marginBottom: (0, scale_1.scale)(30),
                alignItems: "center",
            } },
            react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row", marginBottom: (0, scale_1.scale)(5) } },
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.textBottom, onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                            screen: Routes_1.default.POLICY_DETAIL_SCREEN,
                            params: {
                                index: 0,
                                itemIndex: 0,
                                from: 'input_password',
                            }
                        });
                    } }, "\u5229\u7528\u898F\u7D04"),
                react_1.default.createElement(CustomText_1.default, { style: { top: react_native_1.Platform.OS == "web" ? (0, scale_1.scale)(-5) : 0 } }, "\u30FB"),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.textBottom, onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                            screen: Routes_1.default.POLICY_DETAIL_SCREEN,
                            params: {
                                index: 2,
                                itemIndex: 0,
                                from: 'input_password',
                            }
                        });
                    } }, "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC")),
            react_1.default.createElement(CustomText_1.default, { style: {
                    fontSize: (0, scale_1.moderateScale)(10),
                    lineHeight: (0, scale_1.moderateScale)(15),
                    fontWeight: "300",
                    color: "#292A33",
                } }, "Powered by Fujisan Magazine Service Co., Ltd.")),
        react_1.default.createElement(ModalExplain_1.default, { visible: visiblePassWord, onClose: () => {
                setVisiblePassWord(false);
            }, title: "Fujisan ID\u306B\u3064\u3044\u3066", content: "\u6295\u8CC7\u306E\u5148\u8F29\u3067\u306F\u3001\u682A\u5F0F\u4F1A\u793E\u5BCC\u58EB\u5C71\u30DE\u30AC\u30B8\u30F3\u30B5\u30FC\u30D3\u30B9\u304C\u63D0\u4F9B\u3057\u3066\u3044\u308B Fujisan ID \u3092\u30ED\u30B0\u30A4\u30F3\u306B\u4F7F\u7528\u3057\u3066\u3044\u307E\u3059\u3002" }),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = InputPassword;
